import { padding } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionEight = () => {
  const translations = useTranslations();

  return (
    <Section
      title={translations.patientForms.drvGeneralForm.sectionSeven.title}
    >
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          bold
          elementName="doctor_in_charge_in_hospital"
          label={translations.patientForms.drvGeneralForm.sectionSix.doctorName}
          large
        />
        <TextInputWithLabel
          bold
          elementName="doctor_in_charge_in_hospital_first_name"
          label={translations.patientForms.drvGeneralForm.doctorFirstName}
          large
        />
        <TextInputWithLabel
          bold
          elementName="doctor_in_charge_in_hospital_phone"
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorPhone
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="street_house_number_doctor"
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorStreet
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="postal_code_doctor"
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorZipCode
          }
        />
        <TextInputWithLabel
          bold
          elementName="town_doctor"
          label={
            translations.patientForms.drvGeneralForm.sectionSeven.doctorCity
          }
          large
        />
      </SectionRow>
    </Section>
  );
};
